/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-09-08 17:10:50
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-18 20:08:27
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Radio,
  Row,
  Select,
  Spin,
  Switch,
  TimePicker,
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from '../functionSettingTabs.module.css'
import { RootDispatch } from '../../../app/store'
import { SelectPeopleModal } from './selectPeopleModal'
import {
  CKLRSJTypeOptions,
  commonTypeOptions,
  DCDYQXTypeOptions,
  getCKLRSJTypeName,
  getCommonTypeName,
  getDCDYQXTypeName,
  getModuleName,
  getQKBLCLEARTypeName,
  getSCGHSJTypeName,
  getSJQXChecksName,
  getXGBLCFTypeName,
  getYSCKJYCXTypeName,
  getYSCKJZMKTypeName,
  getYSCKJZSJTypeName,
  getYSCKLSBLTypeName,
  getYSKFTypeName,
  getYSSJKTypeName,
  getXGZFFSTypeName,
  JQXCheckOptions,
  SCGHSJTypeOption,
  SCGHSJTypeOptions,
  QKBLCLEARTypeOptions,
  SJQXChecks,
  xgblcfypeOptions,
  YSCKJYCXTypeOptions,
  YSCKJZMKTypeOptions,
  YSCKJZSJTypeOptions,
  YSCKLSBLTypeOptions,
  yskfTypeOptions,
  YSSJKTypeOptions,
  XGZFFSTypeTypeOptions
} from '../../../models/dataPersion'
import { geDataPermissonListAsync, getSubmitBatchAsync } from './dataPermissionSlice'
import { selectCredentials, selectEdition, selectTenantCategory } from '../../../app/applicationSlice'

export const DataPermission = (props: {
  selectedTab?: any
  membersStatus?: any
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const hisVersion = useSelector(selectEdition)

  const tenantCategory = useSelector(selectTenantCategory)

  const credentials = useSelector(selectCredentials)

  const [form] = Form.useForm()

  const [loading, setLoading] = useState(false)

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [assignedUserIds, setAssignedUserIds] = useState<any>({})

  const [buttonLoading, setButtonLoading] = useState(false)

  const [checksFlag, setChecksFlag] = useState<any>()

  const [data, setData] = useState<any>()

  const getDetail = () => {
    setLoading(true)
    dispatch(geDataPermissonListAsync())
      .then(unwrapResult)
      .then((v: any) => {
        const YSCKJZMK = v?.filter((item: any) => item?.itemCode == SJQXChecks.YSCKJZMK) //医生查看就诊模块
        const YSSJK = v?.filter((item: any) => item?.itemCode == SJQXChecks.YSSJK) //营收数据块
        const SCGHSJ = v?.filter((item: any) => item?.itemCode == SJQXChecks.SCGHSJ) //删除挂号数据
        const CKLRSJ = v?.filter((item: any) => item?.itemCode == SJQXChecks.CKLRSJ) //查看利润数据
        const YSCKJYCX = v?.filter((item: any) => item?.itemCode == SJQXChecks.YSCKJYCX) //医生查看交易查询
        const DCDYQX = v?.filter((item: any) => item?.itemCode == SJQXChecks.DCDYQX) //导出/打印权限
        const YSCKJZSJ = v?.filter((item: any) => item?.itemCode == SJQXChecks.YSCKJZSJ) //医生查看就诊数据
        const YSCKLSBL = v?.filter((item: any) => item?.itemCode == SJQXChecks.YSCKLSBL) //医生查看历史病历
        const WJSXGJZYS = v?.filter((item: any) => item?.itemCode == SJQXChecks.WJSXGJZYS) //未结算修改接诊医生
        const YJSXGJZYS = v?.filter((item: any) => item?.itemCode == SJQXChecks.YJSXGJZYS) //已结算修改接诊医生
        const YSKFXGJG = v?.filter((item: any) => item?.itemCode == SJQXChecks.YSKFXGJG) //医生开方修改价格
        const QTRXGBLCF = v?.filter((item: any) => item?.itemCode == SJQXChecks.QTRXGBLCF) //其他人修改病历/处方
        const YSGZZDCDYQX = v?.filter((item: any) => item?.itemCode == SJQXChecks.YSGZZDCDYQX) //导出/打印权限
        const KFGZZCKLRSJ = v?.filter((item: any) => item?.itemCode == SJQXChecks.KFGZZCKLRSJ) //库房工作站查看利润数据
        const KFGZZDCDYQX = v?.filter((item: any) => item?.itemCode == SJQXChecks.KFGZZDCDYQX) //库房工作站导出/打印权限
        const SFDCDYQX = v?.filter((item: any) => item?.itemCode == SJQXChecks.SFDCDYQX) //收费导出/打印权限
        const SYCKHRSJH = v?.filter((item: any) => item?.itemCode == SJQXChecks.SYCKHRSJH) //首页查看患者手机号
        const YSMZCKHRSJH = v?.filter((item: any) => item?.itemCode == SJQXChecks.YSMZCKHRSJH) //医生门诊查看患者手机号
        const KSKDCKHRSJH = v?.filter((item: any) => item?.itemCode == SJQXChecks.KSKDCKHRSJH) //快速开单查看患者手机号
        const TJFXCKHRSJH = v?.filter((item: any) => item?.itemCode == SJQXChecks.TJFXCKHRSJH) //统计分析查看患者手机号
        const GLSZCKHRSJH = v?.filter((item: any) => item?.itemCode == SJQXChecks.GLSZCKHRSJH) //管理设置查看患者手机号
        const SFCKHRSJH = v?.filter((item: any) => item?.itemCode == SJQXChecks.SFCKHRSJH) //随访查看患者手机号
        const GHCKHZSJH = v?.filter((item: any) => item?.itemCode == SJQXChecks.GHCKHZSJH) //挂号查看患者手机号权限
        const YYCKHZSJH = v?.filter((item: any) => item?.itemCode == SJQXChecks.YYCKHZSJH) //预约查看患者手机号权限
        const YSGZZCKHZSJH = v?.filter((item: any) => item?.itemCode == SJQXChecks.YSGZZCKHZSJH) //医生工作站查看患者手机号权限
        const YJZCKHZSJH = v?.filter((item: any) => item?.itemCode == SJQXChecks.YJZCKHZSJH) //医技站查看患者手机号权限
        const HYGLCKHZSJH = v?.filter((item: any) => item?.itemCode == SJQXChecks.HYGLCKHZSJH) //会员管理查看患者手机号权限
        const HSGZZCKHZSJH = v?.filter((item: any) => item?.itemCode == SJQXChecks.HSGZZCKHZSJH) //护士工作站查看患者手机号权限
        const HZGLCKHZSJH = v?.filter((item: any) => item?.itemCode == SJQXChecks.HZGLCKHZSJH) //患者管理查看患者手机号权限
        const SFXGZFFS = v?.filter((item: any) => item?.itemCode == SJQXChecks.SFXGZFFS) //修改支付方式
        const SFXGSFMX = v?.filter((item: any) => item?.itemCode == SJQXChecks.SFXGSFMX) //修改收费明细
        const GHCKHZSFZH = v?.filter((item: any) => item?.itemCode == SJQXChecks.GHCKHZSFZH) //挂号查看患者身份证号权限
        const YSMZCKHZSFZH = v?.filter((item: any) => item?.itemCode == SJQXChecks.YSMZCKHZSFZH) //医生门诊查看患者身份证号权限
        const SYCKHHZSFZH = v?.filter((item: any) => item?.itemCode == SJQXChecks.SYCKHHZSFZH) //口腔首页查看患者身份证号权限
        const TJFXCKHZSFZH = v?.filter((item: any) => item?.itemCode == SJQXChecks.TJFXCKHZSFZH) //统计分析查看患者身份证号权限
        const HZGLCKHZSFZH = v?.filter((item: any) => item?.itemCode == SJQXChecks.HZGLCKHZSFZH) //患者管理查看患者身份证号权限
        const QKBLCLEAR = v?.filter((item: any) => item?.itemCode == SJQXChecks.QKBLCLEAR) //患者管理清空病历
        const KSKDCKHZSFZH = v?.filter((item: any) => item?.itemCode == SJQXChecks.KSKDCKHZSFZH) //快速开单查看患者身份证号权限
        const SFCKHZSFZH = v?.filter((item: any) => item?.itemCode == SJQXChecks.SFCKHZSFZH) //随访查看患者身份证号权限
        const YYCKHZSFZH = v?.filter((item: any) => item?.itemCode == SJQXChecks.YYCKHZSFZH) //预约查看患者身份证号权限
        const YSGZZCKHZSFZH = v?.filter((item: any) => item?.itemCode == SJQXChecks.YSGZZCKHZSFZH) //医生工作站查看患者身份证号权限
        setData(v)
        form.setFieldsValue({
          [SJQXChecks.YSCKJZMK]: YSCKJZMK?.[0]?.configValue || 2, //医生查看就诊模块
          [SJQXChecks.YSSJK]: YSSJK?.[0]?.configValue || 1, //营收数据块
          [SJQXChecks.SCGHSJ]: hisVersion == 1 && SCGHSJ?.[0]?.configValue == 1 ? 2 : SCGHSJ?.[0]?.configValue || 2, //删除挂号数据
          [SJQXChecks.CKLRSJ]: CKLRSJ?.[0]?.configValue || 1, //查看利润数据
          [SJQXChecks.YSCKJYCX]: YSCKJYCX?.[0]?.configValue || 1, //医生查看交易查询
          [SJQXChecks.DCDYQX]: DCDYQX?.[0]?.configValue || 1, //导出/打印权限
          [SJQXChecks.YSCKJZSJ]: YSCKJZSJ?.[0]?.configValue || 1, //医生查看就诊数据
          [SJQXChecks.YSCKLSBL]: YSCKLSBL?.[0]?.configValue || 2, //医生查看历史病历
          [SJQXChecks.WJSXGJZYS]: WJSXGJZYS?.[0]?.configValue || 1, //未结算修改接诊医生
          [SJQXChecks.YJSXGJZYS]: YJSXGJZYS?.[0]?.configValue || 1, //已结算修改接诊医生
          [SJQXChecks.YSKFXGJG]: YSKFXGJG?.[0]?.configValue?.toString() ? YSKFXGJG?.[0]?.configValue : 0, //医生开方修改价格
          [SJQXChecks.QTRXGBLCF]: QTRXGBLCF?.[0]?.configValue?.toString() ? QTRXGBLCF?.[0]?.configValue : 1, //其他人修改病历/处方
          [SJQXChecks.YSGZZDCDYQX]: YSGZZDCDYQX?.[0]?.configValue || 1, //医生工作站导出/打印权限
          [SJQXChecks.KFGZZCKLRSJ]: KFGZZCKLRSJ?.[0]?.configValue || 1, //库房工作站查看利润数据
          [SJQXChecks.KFGZZDCDYQX]: KFGZZDCDYQX?.[0]?.configValue || 1, //库房工作站导出/打印权限
          [SJQXChecks.SFDCDYQX]: SFDCDYQX?.[0]?.configValue || 1, //收费导出/打印权限
          [SJQXChecks.SYCKHRSJH]: SYCKHRSJH?.[0]?.configValue || 1, //首页查看患者手机号
          [SJQXChecks.YSMZCKHRSJH]: YSMZCKHRSJH?.[0]?.configValue || 1, //医生门诊查看患者手机号
          [SJQXChecks.KSKDCKHRSJH]: KSKDCKHRSJH?.[0]?.configValue || 1, //快速开单查看患者手机号
          [SJQXChecks.TJFXCKHRSJH]: TJFXCKHRSJH?.[0]?.configValue || 1, //统计分析查看患者手机号
          [SJQXChecks.GLSZCKHRSJH]: GLSZCKHRSJH?.[0]?.configValue || 1, //管理设置查看患者手机号
          [SJQXChecks.SFCKHRSJH]: SFCKHRSJH?.[0]?.configValue || 1, //随访查看患者手机号
          [SJQXChecks.GHCKHZSJH]: GHCKHZSJH?.[0]?.configValue || 1, //挂号查看患者手机号权限
          [SJQXChecks.YYCKHZSJH]: YYCKHZSJH?.[0]?.configValue || 1, //预约查看患者手机号权限
          [SJQXChecks.YSGZZCKHZSJH]: YSGZZCKHZSJH?.[0]?.configValue || 1, //医生工作站查看患者手机号权限
          [SJQXChecks.YJZCKHZSJH]: YJZCKHZSJH?.[0]?.configValue || 1, //医技站查看患者手机号权限
          [SJQXChecks.HYGLCKHZSJH]: HYGLCKHZSJH?.[0]?.configValue || 1, //会员管理查看患者手机号权限
          [SJQXChecks.HSGZZCKHZSJH]: HSGZZCKHZSJH?.[0]?.configValue || 1, //护士工作站查看患者手机号权限
          [SJQXChecks.HZGLCKHZSJH]: HZGLCKHZSJH?.[0]?.configValue || 1, //患者管理查看患者手机号权限
          [SJQXChecks.SFXGZFFS]: SFXGZFFS?.[0]?.configValue || 1, //修改支付方式
          [SJQXChecks.SFXGSFMX]: SFXGSFMX?.[0]?.configValue || 2, //修改收费明细
          [SJQXChecks.GHCKHZSFZH]: GHCKHZSFZH?.[0]?.configValue || 1, //挂号查看患者身份证号权限
          [SJQXChecks.YSMZCKHZSFZH]: YSMZCKHZSFZH?.[0]?.configValue || 1, //医生门诊查看患者身份证号权限
          [SJQXChecks.SYCKHHZSFZH]: SYCKHHZSFZH?.[0]?.configValue || 1, //口腔首页查看患者身份证号权限
          [SJQXChecks.TJFXCKHZSFZH]: TJFXCKHZSFZH?.[0]?.configValue || 1, //统计分析查看患者身份证号权限
          [SJQXChecks.HZGLCKHZSFZH]: HZGLCKHZSFZH?.[0]?.configValue || 1, //患者管理查看患者身份证号权限
          [SJQXChecks.QKBLCLEAR]: QKBLCLEAR?.[0]?.configValue || 2, //患者管理清空病历
          [SJQXChecks.KSKDCKHZSFZH]: KSKDCKHZSFZH?.[0]?.configValue || 1, //快速开单查看患者身份证号权限
          [SJQXChecks.SFCKHZSFZH]: SFCKHZSFZH?.[0]?.configValue || 1, //随访查看患者身份证号权限
          [SJQXChecks.YYCKHZSFZH]: YYCKHZSFZH?.[0]?.configValue || 1, //预约查看患者身份证号权限
          [SJQXChecks.YSGZZCKHZSFZH]: YSGZZCKHZSFZH?.[0]?.configValue || 1, //医生工作站查看患者身份证号权限
        })
        setAssignedUserIds({
          [SJQXChecks.YSCKJZMK]: YSCKJZMK?.[0]?.assignedUserIds?.split(',') || [],//医生查看就诊模块
          [SJQXChecks.YSSJK]: YSSJK?.[0]?.assignedUserIds?.split(',') || [], //营收数据块
          [SJQXChecks.SCGHSJ]: SCGHSJ?.[0]?.assignedUserIds?.split(',') || [], //删除挂号数据
          [SJQXChecks.CKLRSJ]: CKLRSJ?.[0]?.assignedUserIds?.split(',') || [], //查看利润数据
          [SJQXChecks.YSCKJYCX]: YSCKJYCX?.[0]?.assignedUserIds?.split(',') || [], //医生查看交易查询
          [SJQXChecks.DCDYQX]: DCDYQX?.[0]?.assignedUserIds?.split(',') || [], //导出/打印权限
          [SJQXChecks.YSCKJZSJ]: YSCKJZSJ?.[0]?.assignedUserIds?.split(',') || [], //医生查看就诊数据
          [SJQXChecks.YSCKLSBL]: YSCKLSBL?.[0]?.assignedUserIds?.split(',') || [], //医生查看历史病历
          [SJQXChecks.WJSXGJZYS]: WJSXGJZYS?.[0]?.assignedUserIds?.split(',') || [], //未结算修改接诊医生
          [SJQXChecks.YJSXGJZYS]: YJSXGJZYS?.[0]?.assignedUserIds?.split(',') || [], //已结算修改接诊医生
          [SJQXChecks.YSKFXGJG]: YSKFXGJG?.[0]?.assignedUserIds?.split(',') || [], //医生开方修改价格
          [SJQXChecks.QTRXGBLCF]: QTRXGBLCF?.[0]?.assignedUserIds?.split(',') || [], //其他人修改病历/处方
          [SJQXChecks.YSGZZDCDYQX]: YSGZZDCDYQX?.[0]?.assignedUserIds?.split(',') || [], //医生工作站导出/打印权限
          [SJQXChecks.KFGZZCKLRSJ]: KFGZZCKLRSJ?.[0]?.assignedUserIds?.split(',') || [], //库房工作站查看利润数据
          [SJQXChecks.KFGZZDCDYQX]: KFGZZDCDYQX?.[0]?.assignedUserIds?.split(',') || [], //库房工作站导出/打印权限
          [SJQXChecks.SFDCDYQX]: SFDCDYQX?.[0]?.assignedUserIds?.split(',') || [], //收费导出/打印权限
          [SJQXChecks.SYCKHRSJH]: SYCKHRSJH?.[0]?.assignedUserIds?.split(',') || [], //首页查看患者手机号
          [SJQXChecks.YSMZCKHRSJH]: YSMZCKHRSJH?.[0]?.assignedUserIds?.split(',') || [], //医生门诊查看患者手机号
          [SJQXChecks.KSKDCKHRSJH]: KSKDCKHRSJH?.[0]?.assignedUserIds?.split(',') || [], //快速开单查看患者手机号
          [SJQXChecks.TJFXCKHRSJH]: TJFXCKHRSJH?.[0]?.assignedUserIds?.split(',') || [], //统计分析查看患者手机号
          [SJQXChecks.GLSZCKHRSJH]: GLSZCKHRSJH?.[0]?.assignedUserIds?.split(',') || [], //管理设置查看患者手机号
          [SJQXChecks.SFCKHRSJH]: SFCKHRSJH?.[0]?.assignedUserIds?.split(',') || [], //随访查看患者手机号
          [SJQXChecks.GHCKHZSJH]: GHCKHZSJH?.[0]?.assignedUserIds?.split(',') || [], //挂号查看患者手机号权限
          [SJQXChecks.YYCKHZSJH]: YYCKHZSJH?.[0]?.assignedUserIds?.split(',') || [], //预约查看患者手机号权限
          [SJQXChecks.YSGZZCKHZSJH]: YSGZZCKHZSJH?.[0]?.assignedUserIds?.split(',') || [], //医生工作站查看患者手机号权限
          [SJQXChecks.YJZCKHZSJH]: YJZCKHZSJH?.[0]?.assignedUserIds?.split(',') || [], //医技站查看患者手机号权限
          [SJQXChecks.HYGLCKHZSJH]: HYGLCKHZSJH?.[0]?.assignedUserIds?.split(',') || [], //会员管理查看患者手机号权限
          [SJQXChecks.HSGZZCKHZSJH]: HSGZZCKHZSJH?.[0]?.assignedUserIds?.split(',') || [], //护士工作站查看患者手机号权限
          [SJQXChecks.HZGLCKHZSJH]: HZGLCKHZSJH?.[0]?.assignedUserIds?.split(',') || [], //患者管理查看患者手机号权限
          [SJQXChecks.SFXGZFFS]: SFXGZFFS?.[0]?.assignedUserIds?.split(',') || [], //收费修改支付方式
          [SJQXChecks.SFXGSFMX]: SFXGSFMX?.[0]?.assignedUserIds?.split(',') || [], //收费修改收费明细
          [SJQXChecks.GHCKHZSFZH]: GHCKHZSFZH?.[0]?.assignedUserIds?.split(',') || [], //挂号查看患者身份证号权限
          [SJQXChecks.YSMZCKHZSFZH]: YSMZCKHZSFZH?.[0]?.assignedUserIds?.split(',') || [], //医生门诊查看患者身份证号权限
          [SJQXChecks.SYCKHHZSFZH]: SYCKHHZSFZH?.[0]?.assignedUserIds?.split(',') || [], //口腔首页查看患者身份证号权限
          [SJQXChecks.TJFXCKHZSFZH]: TJFXCKHZSFZH?.[0]?.assignedUserIds?.split(',') || [], //统计分析查看患者身份证号权限
          [SJQXChecks.HZGLCKHZSFZH]: HZGLCKHZSFZH?.[0]?.assignedUserIds?.split(',') || [], //患者管理查看患者身份证号权限
          [SJQXChecks.QKBLCLEAR]: QKBLCLEAR?.[0]?.assignedUserIds?.split(',') || [], //患者管理清空病历
          [SJQXChecks.KSKDCKHZSFZH]: KSKDCKHZSFZH?.[0]?.assignedUserIds?.split(',') || [], //快速开单查看患者身份证号权限
          [SJQXChecks.SFCKHZSFZH]: SFCKHZSFZH?.[0]?.assignedUserIds?.split(',') || [], //随访查看患者身份证号权限
          [SJQXChecks.YYCKHZSFZH]: YYCKHZSFZH?.[0]?.assignedUserIds?.split(',') || [], //预约查看患者身份证号权限
          [SJQXChecks.YSGZZCKHZSFZH]: YSGZZCKHZSFZH?.[0]?.assignedUserIds?.split(',') || [], //医生工作站查看患者身份证号权限
        })
      })
      .catch((err) => {
        form.setFieldsValue({
          [SJQXChecks.YSCKJZMK]: 2,//医生查看就诊模块
          [SJQXChecks.YSSJK]: 1, //营收数据块
          [SJQXChecks.SCGHSJ]: 2, //删除挂号数据
          [SJQXChecks.CKLRSJ]: 1, //查看利润数据
          [SJQXChecks.YSCKJYCX]: 1, //医生查看交易查询
          [SJQXChecks.DCDYQX]: 1, //导出/打印权限
          [SJQXChecks.YSCKJZSJ]: 1, //医生查看就诊数据
          [SJQXChecks.YSCKLSBL]: 2, //医生查看历史病历
          [SJQXChecks.WJSXGJZYS]: 1, //未结算修改接诊医生
          [SJQXChecks.YJSXGJZYS]: 1, //已结算修改接诊医生
          [SJQXChecks.YSKFXGJG]: 0, //医生开方修改价格
          [SJQXChecks.QTRXGBLCF]: 1, //其他人修改病历/处方
          [SJQXChecks.YSGZZDCDYQX]: 1, //医生工作站导出/打印权限
          [SJQXChecks.KFGZZCKLRSJ]: 1, //库房工作站查看利润数据
          [SJQXChecks.KFGZZDCDYQX]: 1, //库房工作站导出/打印权限
          [SJQXChecks.SFDCDYQX]: 1, //收费导出/打印权限
          [SJQXChecks.SYCKHRSJH]: 1, //首页查看患者手机号
          [SJQXChecks.YSMZCKHRSJH]: 1, //医生门诊查看患者手机号
          [SJQXChecks.KSKDCKHRSJH]: 1, //快速开单查看患者手机号
          [SJQXChecks.TJFXCKHRSJH]: 1, //统计分析查看患者手机号
          [SJQXChecks.GLSZCKHRSJH]: 1, //管理设置查看患者手机号
          [SJQXChecks.SFCKHRSJH]: 1, //随访查看患者手机号
          [SJQXChecks.GHCKHZSJH]: 1, //挂号查看患者手机号权限
          [SJQXChecks.YYCKHZSJH]: 1, //预约查看患者手机号权限
          [SJQXChecks.YSGZZCKHZSJH]: 1, //医生工作站查看患者手机号权限
          [SJQXChecks.YJZCKHZSJH]: 1, //医技站查看患者手机号权限
          [SJQXChecks.HYGLCKHZSJH]: 1, //会员管理查看患者手机号权限
          [SJQXChecks.HSGZZCKHZSJH]: 1, //护士工作站查看患者手机号权限
          [SJQXChecks.HZGLCKHZSJH]: 1, //患者管理查看患者手机号权限
          [SJQXChecks.SFXGZFFS]: 1, //收费修改支付方式
          [SJQXChecks.SFXGSFMX]: 2, //收费修改收费明细
          [SJQXChecks.GHCKHZSFZH]: 1, //挂号查看患者身份证号权限
          [SJQXChecks.YSMZCKHZSFZH]: 1, //医生门诊查看患者身份证号权限
          [SJQXChecks.SYCKHHZSFZH]: 1, //口腔首页查看患者身份证号权限
          [SJQXChecks.TJFXCKHZSFZH]: 1, //统计分析查看患者身份证号权限
          [SJQXChecks.HZGLCKHZSFZH]: 1, //患者管理查看患者身份证号权限
          [SJQXChecks.QKBLCLEAR]: 2, //患者管理清空病历
          [SJQXChecks.KSKDCKHZSFZH]: 1, //快速开单查看患者身份证号权限
          [SJQXChecks.SFCKHZSFZH]: 1, //随访查看患者身份证号权限
          [SJQXChecks.YYCKHZSFZH]: 1, //预约查看患者身份证号权限
          [SJQXChecks.YSGZZCKHZSFZH]: 1, //医生工作站查看患者身份证号权限
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (props?.selectedTab == '2') {
      getDetail()
    }
  }, [props?.selectedTab])

  const clearMessage = () => {
    setAssignedUserIds({})
    setChecksFlag('')
  }

  const setCheck = (v: any) => {
    setChecksFlag(v)
  }

  const patientPhonePermissionCode = hisVersion == 1
    ? SJQXChecks.HZGLCKHZSJH
    : SJQXChecks.YSMZCKHRSJH

  const patientIdCardPermissionCode = hisVersion == 1
    ? SJQXChecks.HZGLCKHZSFZH
    : SJQXChecks.YSMZCKHZSFZH

  // 未结算/已结算修改接诊医生的菜单权限：口腔版为患者管理，通用版为医生门诊
  const jzysModuleName = hisVersion == 1 ? '患者管理' : '医生门诊'

  return (
    <>
      <div className={styles.dataPermissionMain}>
        <Spin spinning={loading} style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}></Spin>
        <>
          <Form
            form={form}
            autoComplete='off'
            style={{ height: '100%' }}
            onFinish={(values) => {
              const getConfigName = (v: any) => {
                if (v == SJQXChecks.YSCKJZMK) { //医生查看就诊模块
                  return getYSCKJZMKTypeName(values[v])
                } else if (v == SJQXChecks.YSSJK) { //营收数据块
                  return getYSSJKTypeName(values[v])
                } else if (v == SJQXChecks.YSCKJYCX) { //医生查看交易查询
                  return getYSCKJYCXTypeName(values[v])
                } else if (v == SJQXChecks.CKLRSJ) { //查看利润数据
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.DCDYQX) { //导出/打印权限
                  return getDCDYQXTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.SCGHSJ) { //删除挂号数据
                  return getSCGHSJTypeName(values[v])
                } else if (v == SJQXChecks.YSCKJZSJ) { //医生查看就诊数据
                  return getYSCKJZSJTypeName(values[v])
                } else if (v == SJQXChecks.YSCKLSBL) { //医生查看历史病历
                  return getYSCKLSBLTypeName(values[v])
                } else if (v == SJQXChecks.WJSXGJZYS) { //未结算修改接诊医生
                  return getCommonTypeName(values[v], jzysModuleName)
                } else if (v == SJQXChecks.YJSXGJZYS) { //已结算修改接诊医生
                  return getCommonTypeName(values[v], jzysModuleName)
                } else if (v == SJQXChecks.YSKFXGJG) { //医生开方修改价格
                  return getYSKFTypeName(values[v])
                } else if (v == SJQXChecks.QTRXGBLCF) { //其他人修改病历/处方
                  return getXGBLCFTypeName(values[v])
                } else if (v == SJQXChecks.YSGZZDCDYQX) { //医生工作站导出/打印权限
                  return getDCDYQXTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.KFGZZCKLRSJ) { //库房工作站查看利润数据
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.KFGZZDCDYQX) { //库房工作站导出/打印权限
                  return getDCDYQXTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.SFDCDYQX) { //收费导出/打印权限
                  return getDCDYQXTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.GHCKHZSJH) { //挂号查看患者手机号权限
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.YYCKHZSJH) { //预约查看患者手机号权限
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.YSGZZCKHZSJH) { //医生工作站查看患者手机号权限
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.YJZCKHZSJH) { //医技站查看患者手机号权限
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.HYGLCKHZSJH) { //会员管理查看患者手机号权限
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.HSGZZCKHZSJH) { //护士工作站查看患者手机号权限
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.HZGLCKHZSJH) { //患者管理查看患者手机号权限
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.SFXGZFFS) { //收费修改支付方式
                  return getXGZFFSTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.SFXGSFMX) { //收费修改收费明细
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.SYCKHRSJH) { //首页查看患者手机号
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.YSMZCKHRSJH) { //医生门诊查看患者手机号
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.KSKDCKHRSJH) { //快速开单查看患者手机号
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.TJFXCKHRSJH) { //统计分析查看患者手机号
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.GLSZCKHRSJH) { //管理设置查看患者手机号
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.SFCKHRSJH) { //随访查看患者手机号
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.GHCKHZSFZH) { //挂号查看患者身份证号权限
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.YYCKHZSFZH) { //预约查看患者身份证号权限
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.YSMZCKHZSFZH) { //医生门诊查看患者身份证号权限
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.YSGZZCKHZSFZH) { //医生工作站查看患者身份证号权限
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.SYCKHHZSFZH) { //口腔首页查看患者身份证号权限
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.TJFXCKHZSFZH) { //统计分析查看患者身份证号权限
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.HZGLCKHZSFZH) { //患者管理查看患者身份证号权限
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.QKBLCLEAR) { //患者管理清空病历
                  return getQKBLCLEARTypeName(values[v])
                } else if (v == SJQXChecks.KSKDCKHZSFZH) { //快速开单查看患者身份证号权限
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                } else if (v == SJQXChecks.SFCKHZSFZH) { //随访查看患者身份证号权限
                  return getCKLRSJTypeName(values[v], getModuleName(v))
                }
              }


              setButtonLoading(true)
              const options = hisVersion == 1 ?
                //口腔版过滤 挂号查看患者手机号权限 医生门诊查看患者手机号 //挂号查看患者身份证号权限
                JQXCheckOptions.filter((v: any) =>
                  v != SJQXChecks.GHCKHZSJH && v != SJQXChecks.YSMZCKHRSJH && v != SJQXChecks.YSMZCKHZSFZH && v != SJQXChecks.GHCKHZSFZH
                ) :
                //非口腔版过滤 营收数据块 首页查看患者手机号  首页查看患者身份证号  患者管理清空病历
                JQXCheckOptions.filter((v: any) =>   v != SJQXChecks.YSSJK && v != SJQXChecks.SYCKHRSJH && v != SJQXChecks.SYCKHHZSFZH && v != SJQXChecks.QKBLCLEAR)
              console.log('valuesvaluesvalues', options)

              const results = options?.map((v) => {
                const assIds = assignedUserIds?.[v]?.filter((v: string) => v != ' ')?.join(',')
                return {
                  assignedUserIds: v == SJQXChecks.YSCKJYCX || values[v] != 99 ? ' ' : assIds || '',  // 所有选中的用户ID（逗号分隔）
                  configName: getConfigName(v),  // 配置名称
                  configValue: values[v],  // 配置值
                  id: data?.filter((item: any) => item?.itemCode == v)?.[0]?.id,
                  itemCode: v,
                  itemName: getSJQXChecksName(v),
                  moduleName: v == SJQXChecks.WJSXGJZYS || v == SJQXChecks.YJSXGJZYS ? jzysModuleName : getModuleName(v),
                }
              })
              dispatch(getSubmitBatchAsync(results))
                .then(unwrapResult)
                .then((v: any) => {
                  notification.success({
                    message: '操作成功',
                  })
                  getDetail()
                  clearMessage()
                })
                .finally(() => {
                  setButtonLoading(false)
                })
            }}
          >
            <div style={{ overflow: 'auto', height: 'calc(100% - 50px)' }}>
              <>
                <Row
                  style={{
                    fontSize: 16,
                    fontWeight: 'bold',
                    borderBottom: '1px dashed #BBBBBB',
                    paddingBottom: '10px',
                    width: '100%',
                  }}
                >
                  首页
                </Row>
                <div className={styles.contentJJ}>
                  {/* 医生查看就诊模块 */}
                  <Col className={styles.rowHeightData} span={24}>
                    <Form.Item
                      label={getSJQXChecksName(SJQXChecks.YSCKJZMK)}
                      name={SJQXChecks.YSCKJZMK}
                    >
                      <Radio.Group
                        onChange={(v) => {
                          setAssignedUserIds((prev: any) => ({
                            ...prev,
                            [SJQXChecks.YSCKJZMK]: []
                          }))
                          const value = v.target.value
                          if (value == 99) {
                            setChecksFlag(SJQXChecks.YSCKJZMK)
                            setIsModalVisible(!isModalVisible)
                          }
                        }}>
                        {YSCKJZMKTypeOptions.map((v) => {
                          return <Radio key={v} value={v} >
                            {getYSCKJZMKTypeName(v)}
                          </Radio>
                        })}
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  {/* 只有口腔版需要营收数据块配置 */}
                  {/* 营收数据块 */}
                  {hisVersion == 1 ?
                    <Col className={styles.rowHeightData} span={24}>
                      <Form.Item
                        label={getSJQXChecksName(SJQXChecks.YSSJK)}
                        name={SJQXChecks.YSSJK}
                      >
                        <Radio.Group
                          onChange={(v) => {
                            setAssignedUserIds((prev: any) => ({
                              ...prev,
                              [SJQXChecks.YSSJK]: []
                            }))
                            const value = v.target.value
                            if (value == 99) {
                              setChecksFlag(SJQXChecks.YSSJK)
                              setIsModalVisible(!isModalVisible)
                            }
                          }}>
                          {YSSJKTypeOptions.map((v) => {
                            return <Radio key={v} value={v} >
                              {getYSSJKTypeName(v)}
                              {v == 99 ?
                                <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                                  onClick={() => {
                                    form.setFieldsValue({
                                      [SJQXChecks.YSSJK]: 99,
                                    })
                                    setChecksFlag(SJQXChecks.YSSJK)
                                    setIsModalVisible(!isModalVisible)
                                  }}
                                >查看编辑</span> : ''}</Radio>
                          })}
                        </Radio.Group>
                      </Form.Item>
                    </Col> : ''}
                  {/* 只有口腔版需要查看患者手机号配置 */}
                  {/* 查看患者手机号 */}
                  {hisVersion == 1 ? <Col className={styles.rowHeightData} span={24}>
                    <Form.Item
                      label={getSJQXChecksName(SJQXChecks.SYCKHRSJH)}
                      name={SJQXChecks.SYCKHRSJH}
                    >
                      <Radio.Group
                        onChange={(v) => {
                          setAssignedUserIds((prev: any) => ({
                            ...prev,
                            [SJQXChecks.SYCKHRSJH]: []
                          }))
                          const value = v.target.value
                          if (value == 99) {
                            setChecksFlag(SJQXChecks.SYCKHRSJH)
                            setIsModalVisible(!isModalVisible)
                          }
                        }}>
                        {CKLRSJTypeOptions.map((v) => {
                          return <Radio key={v} value={v} >
                            {getCKLRSJTypeName(v, getModuleName(SJQXChecks.SYCKHRSJH))}
                            {v == 99 ?
                              <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                                onClick={() => {
                                  form.setFieldsValue({
                                    [SJQXChecks.SYCKHRSJH]: 99,
                                  })
                                  setChecksFlag(SJQXChecks.SYCKHRSJH)
                                  setIsModalVisible(!isModalVisible)
                                }}
                              >查看编辑</span> : ''}</Radio>
                        })}
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                    : ''}
                  {/* 只有口腔版需要查看患者手机号配置 */}
                  {/* 查看患者身份证号 */}
                  {hisVersion == 1 ? <Col className={styles.rowHeightData} span={24}>
                    <Form.Item
                      label={getSJQXChecksName(SJQXChecks.SYCKHHZSFZH)}
                      name={SJQXChecks.SYCKHHZSFZH}
                    >
                      <Radio.Group
                        onChange={(v) => {
                          setAssignedUserIds((prev: any) => ({
                            ...prev,
                            [SJQXChecks.SYCKHHZSFZH]: []
                          }))
                          const value = v.target.value
                          if (value == 99) {
                            setChecksFlag(SJQXChecks.SYCKHHZSFZH)
                            setIsModalVisible(!isModalVisible)
                          }
                        }}>
                        {CKLRSJTypeOptions.map((v) => {
                          return <Radio key={v} value={v} >
                            {getCKLRSJTypeName(v, getModuleName(SJQXChecks.SYCKHHZSFZH))}
                            {v == 99 ?
                              <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                                onClick={() => {
                                  form.setFieldsValue({
                                    [SJQXChecks.SYCKHHZSFZH]: 99,
                                  })
                                  setChecksFlag(SJQXChecks.SYCKHHZSFZH)
                                  setIsModalVisible(!isModalVisible)
                                }}
                              >查看编辑</span> : ''}</Radio>
                        })}
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                    : ''}
                </div>
                {hisVersion == 0 ?
                  <Row
                    style={{
                      fontSize: 16,
                      fontWeight: 'bold',
                      borderBottom: '1px dashed #BBBBBB',
                      paddingBottom: '10px',
                      width: '100%',
                    }}
                  >
                    挂号
                  </Row> : <></>}
                <div className={styles.contentJJ}>
                  {/* 删除挂号数据 */}
                  <Col className={styles.rowHeightData} span={24}>
                    <Form.Item
                      label={getSJQXChecksName(SJQXChecks.SCGHSJ)}
                      name={SJQXChecks.SCGHSJ}
                    >
                      <Radio.Group
                        onChange={(v) => {
                          setAssignedUserIds((prev: any) => ({
                            ...prev,
                            [SJQXChecks.SCGHSJ]: []
                          }))
                          const value = v.target.value
                          if (value == 99) {
                            setChecksFlag(SJQXChecks.SCGHSJ)
                            setIsModalVisible(!isModalVisible)
                          }
                        }}>
                        {(hisVersion == 1 ? SCGHSJTypeOption : SCGHSJTypeOptions)?.map((v) => {
                          return <Radio key={v} value={v} >
                            {getSCGHSJTypeName(v)}
                            {v == 99 ?
                              <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                                onClick={() => {
                                  form.setFieldsValue({
                                    [SJQXChecks.SCGHSJ]: 99,
                                  })
                                  setChecksFlag(SJQXChecks.SCGHSJ)
                                  setIsModalVisible(!isModalVisible)
                                }}
                              >查看编辑</span> : ''}</Radio>
                        })}
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  {/* 挂号查看患者手机号，只有通用版显示 */}
                  {hisVersion == 0 ? <Col className={styles.rowHeightData} span={24}>
                    <Form.Item
                      label={getSJQXChecksName(SJQXChecks.GHCKHZSJH)}
                      name={SJQXChecks.GHCKHZSJH}
                    >
                      <Radio.Group
                        onChange={(v) => {
                          setAssignedUserIds((prev: any) => ({
                            ...prev,
                            [SJQXChecks.GHCKHZSJH]: []
                          }))
                          const value = v.target.value
                          if (value == 99) {
                            setChecksFlag(SJQXChecks.GHCKHZSJH)
                            setIsModalVisible(!isModalVisible)
                          }
                        }}>
                        {CKLRSJTypeOptions.map((v) => {
                          return <Radio key={v} value={v} >
                            {getCKLRSJTypeName(v, getModuleName(SJQXChecks.GHCKHZSJH))}
                            {v == 99 ?
                              <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                                onClick={() => {
                                  form.setFieldsValue({
                                    [SJQXChecks.GHCKHZSJH]: 99,
                                  })
                                  setChecksFlag(SJQXChecks.GHCKHZSJH)
                                  setIsModalVisible(!isModalVisible)
                                }}
                              >查看编辑</span> : ''}</Radio>
                        })}
                      </Radio.Group>
                    </Form.Item>
                  </Col> : ''}
                  {/* 挂号查看患者身份证号，只有通用版显示 */}
                  {hisVersion == 0 ? <Col className={styles.rowHeightData} span={24}>
                    <Form.Item
                      label={getSJQXChecksName(SJQXChecks.GHCKHZSFZH)}
                      name={SJQXChecks.GHCKHZSFZH}
                    >
                      <Radio.Group
                        onChange={(v) => {
                          setAssignedUserIds((prev: any) => ({
                            ...prev,
                            [SJQXChecks.GHCKHZSFZH]: []
                          }))
                          const value = v.target.value
                          if (value == 99) {
                            setChecksFlag(SJQXChecks.GHCKHZSFZH)
                            setIsModalVisible(!isModalVisible)
                          }
                        }}>
                        {CKLRSJTypeOptions.map((v) => {
                          return <Radio key={v} value={v} >
                            {getCKLRSJTypeName(v, getModuleName(SJQXChecks.GHCKHZSFZH))}
                            {v == 99 ?
                              <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                                onClick={() => {
                                  form.setFieldsValue({
                                    [SJQXChecks.GHCKHZSFZH]: 99,
                                  })
                                  setChecksFlag(SJQXChecks.GHCKHZSFZH)
                                  setIsModalVisible(!isModalVisible)
                                }}
                              >查看编辑</span> : ''}</Radio>
                        })}
                      </Radio.Group>
                    </Form.Item>
                  </Col> : ''}
                </div>
              </>
              <Row
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  borderBottom: '1px dashed #BBBBBB',
                  paddingBottom: '10px',
                  width: '100%',
                }}
              >
                预约
              </Row>
              <div className={styles.contentJJ}>
                {/* 预约查看患者手机号 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.YYCKHZSJH)}
                    name={SJQXChecks.YYCKHZSJH}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.YYCKHZSJH]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.YYCKHZSJH)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {CKLRSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCKLRSJTypeName(v, getModuleName(SJQXChecks.YYCKHZSJH))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.YYCKHZSJH]: 99,
                                })
                                setChecksFlag(SJQXChecks.YYCKHZSJH)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {/* 预约查看患者身份证号 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.YYCKHZSFZH)}
                    name={SJQXChecks.YYCKHZSFZH}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.YYCKHZSFZH]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.YYCKHZSFZH)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {CKLRSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCKLRSJTypeName(v, getModuleName(SJQXChecks.YYCKHZSFZH))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.YYCKHZSFZH]: 99,
                                })
                                setChecksFlag(SJQXChecks.YYCKHZSFZH)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </div>
              <Row
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  borderBottom: '1px dashed #BBBBBB',
                  paddingBottom: '10px',
                  width: '100%',
                }}
              >
                {hisVersion == 1 ? '患者管理' : '医生门诊'}
              </Row>
              <div className={styles.contentJJ}>
                {/* 医生查看就诊数据 */}
                {/* <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.YSCKJZSJ)}
                    name={SJQXChecks.YSCKJZSJ}
                  >
                    <Radio.Group>
                      {YSCKJZSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getYSCKJZSJTypeName(v)}
                        </Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col> */}
                {/* 医生查看历史病历 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.YSCKLSBL)}
                    name={SJQXChecks.YSCKLSBL}
                  >
                    <Radio.Group>
                      {YSCKLSBLTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getYSCKLSBLTypeName(v)}
                        </Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {/* 未结算修改接诊医生 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.WJSXGJZYS)}
                    name={SJQXChecks.WJSXGJZYS}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.WJSXGJZYS]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.WJSXGJZYS)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {commonTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCommonTypeName(v, jzysModuleName)}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.WJSXGJZYS]: 99,
                                })
                                setChecksFlag(SJQXChecks.WJSXGJZYS)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {/* 已结算修改接诊医生 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.YJSXGJZYS)}
                    name={SJQXChecks.YJSXGJZYS}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.YJSXGJZYS]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.YJSXGJZYS)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {commonTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCommonTypeName(v, jzysModuleName)}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.YJSXGJZYS]: 99,
                                })
                                setChecksFlag(SJQXChecks.YJSXGJZYS)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {/* 医生开方修改价格 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.YSKFXGJG)}
                    name={SJQXChecks.YSKFXGJG}
                  >
                    <Radio.Group
                      onChange={(e) => {
                        return
                      }}
                    >
                      {yskfTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getYSKFTypeName(v)}
                        </Radio>
                      })
                      }
                    </Radio.Group>
                    {/* <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.YSKFXGJG]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.YSKFXGJG)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {commonTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCommonTypeName(v)}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.YSKFXGJG]: 99,
                                })
                                setChecksFlag(SJQXChecks.YSKFXGJG)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group> */}
                  </Form.Item>
                </Col>
                {/* 其他其他人修改病历/处方 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.QTRXGBLCF)}
                    name={SJQXChecks.QTRXGBLCF}
                  >
                    <Radio.Group
                      onChange={(e) => {
                        return
                      }}
                    >
                      {xgblcfypeOptions.map((v: any) => (
                        <Radio key={v} value={v}>
                          {getXGBLCFTypeName(v)}
                        </Radio>
                      ))}
                    </Radio.Group>
                    {/* <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.QTRXGBLCF]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.QTRXGBLCF)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {commonTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCommonTypeName(v)}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.QTRXGBLCF]: 99,
                                })
                                setChecksFlag(SJQXChecks.QTRXGBLCF)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group> */}
                  </Form.Item>
                </Col>
                {/* 查看患者手机号 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(patientPhonePermissionCode)}
                    name={patientPhonePermissionCode}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [patientPhonePermissionCode]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(patientPhonePermissionCode)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {CKLRSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCKLRSJTypeName(v, getModuleName(patientPhonePermissionCode))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [patientPhonePermissionCode]: 99,
                                })
                                setChecksFlag(patientPhonePermissionCode)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {/* 查看患者身份证号 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(patientIdCardPermissionCode)}
                    name={patientIdCardPermissionCode}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [patientIdCardPermissionCode]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(patientIdCardPermissionCode)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {CKLRSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCKLRSJTypeName(v, getModuleName(patientIdCardPermissionCode))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [patientIdCardPermissionCode]: 99,
                                })
                                setChecksFlag(patientIdCardPermissionCode)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {/* 患者管理清空病历（仅口腔版） */}
                {hisVersion == 1 ? <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.QKBLCLEAR)}
                    name={SJQXChecks.QKBLCLEAR}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.QKBLCLEAR]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.QKBLCLEAR)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {QKBLCLEARTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getQKBLCLEARTypeName(v)}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.QKBLCLEAR]: 99,
                                })
                                setChecksFlag(SJQXChecks.QKBLCLEAR)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col> : ''}
              </div>
              <Row
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  borderBottom: '1px dashed #BBBBBB',
                  paddingBottom: '10px',
                  width: '100%',
                }}
              >
                医生工作站
              </Row>
              <div className={styles.contentJJ}>
                {/* 导出/打印权限 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.YSGZZDCDYQX)}
                    name={SJQXChecks.YSGZZDCDYQX}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.YSGZZDCDYQX]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.YSGZZDCDYQX)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {DCDYQXTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getDCDYQXTypeName(v, getModuleName(SJQXChecks.YSGZZDCDYQX))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.YSGZZDCDYQX]: 99,
                                })
                                setChecksFlag(SJQXChecks.YSGZZDCDYQX)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {/* 医生工作站查看患者手机号 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.YSGZZCKHZSJH)}
                    name={SJQXChecks.YSGZZCKHZSJH}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.YSGZZCKHZSJH]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.YSGZZCKHZSJH)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {CKLRSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCKLRSJTypeName(v, getModuleName(SJQXChecks.YSGZZCKHZSJH))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.YSGZZCKHZSJH]: 99,
                                })
                                setChecksFlag(SJQXChecks.YSGZZCKHZSJH)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {/* 医生工作站查看患者身份证号 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.YSGZZCKHZSFZH)}
                    name={SJQXChecks.YSGZZCKHZSFZH}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.YSGZZCKHZSFZH]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.YSGZZCKHZSFZH)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {CKLRSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCKLRSJTypeName(v, getModuleName(SJQXChecks.YSGZZCKHZSFZH))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.YSGZZCKHZSFZH]: 99,
                                })
                                setChecksFlag(SJQXChecks.YSGZZCKHZSFZH)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </div>
              <Row
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  borderBottom: '1px dashed #BBBBBB',
                  paddingBottom: '10px',
                  width: '100%',
                }}
              >
                收费
              </Row>
              <div className={styles.contentJJ}>
                {/* 导出/打印权限 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.SFDCDYQX)}
                    name={SJQXChecks.SFDCDYQX}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.SFDCDYQX]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.SFDCDYQX)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {DCDYQXTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getDCDYQXTypeName(v, getModuleName(SJQXChecks.SFDCDYQX))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.SFDCDYQX]: 99,
                                })
                                setChecksFlag(SJQXChecks.SFDCDYQX)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {/* 修改支付方式 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.SFXGZFFS)}
                    name={SJQXChecks.SFXGZFFS}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.SFXGZFFS]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.SFXGZFFS)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {XGZFFSTypeTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getXGZFFSTypeName(v, getModuleName(SJQXChecks.SFXGZFFS))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.SFXGZFFS]: 99,
                                })
                                setChecksFlag(SJQXChecks.SFXGZFFS)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {/* 修改收费明细 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.SFXGSFMX)}
                    name={SJQXChecks.SFXGSFMX}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.SFXGSFMX]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.SFXGSFMX)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {XGZFFSTypeTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getXGZFFSTypeName(v, getModuleName(SJQXChecks.SFXGSFMX))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.SFXGSFMX]: 99,
                                })
                                setChecksFlag(SJQXChecks.SFXGSFMX)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </div>
              <Row
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  borderBottom: '1px dashed #BBBBBB',
                  paddingBottom: '10px',
                  width: '100%',
                }}
              >
                护士工作站
              </Row>
              <div className={styles.contentJJ}>
                {/* 护士工作站查看患者手机号 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.HSGZZCKHZSJH)}
                    name={SJQXChecks.HSGZZCKHZSJH}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.HSGZZCKHZSJH]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.HSGZZCKHZSJH)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {CKLRSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCKLRSJTypeName(v, getModuleName(SJQXChecks.HSGZZCKHZSJH))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.HSGZZCKHZSJH]: 99,
                                })
                                setChecksFlag(SJQXChecks.HSGZZCKHZSJH)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </div>
              <Row
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  borderBottom: '1px dashed #BBBBBB',
                  paddingBottom: '10px',
                  width: '100%',
                }}
              >
                医技站
              </Row>
              <div className={styles.contentJJ}>
                {/* 医技站查看患者手机号 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.YJZCKHZSJH)}
                    name={SJQXChecks.YJZCKHZSJH}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.YJZCKHZSJH]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.YJZCKHZSJH)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {CKLRSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCKLRSJTypeName(v, getModuleName(SJQXChecks.YJZCKHZSJH))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.YJZCKHZSJH]: 99,
                                })
                                setChecksFlag(SJQXChecks.YJZCKHZSJH)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </div>
              <Row
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  borderBottom: '1px dashed #BBBBBB',
                  paddingBottom: '10px',
                  width: '100%',
                }}
              >
                会员管理
              </Row>
              <div className={styles.contentJJ}>
                {/* 会员管理查看患者手机号 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.HYGLCKHZSJH)}
                    name={SJQXChecks.HYGLCKHZSJH}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.HYGLCKHZSJH]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.HYGLCKHZSJH)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {CKLRSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCKLRSJTypeName(v, getModuleName(SJQXChecks.HYGLCKHZSJH))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.HYGLCKHZSJH]: 99,
                                })
                                setChecksFlag(SJQXChecks.HYGLCKHZSJH)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>

              </div>
              <Row
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  borderBottom: '1px dashed #BBBBBB',
                  paddingBottom: '10px',
                  width: '100%',
                }}
              >
                统计分析
              </Row>
              <div className={styles.contentJJ}>
                {/* 查看利润数据 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.CKLRSJ)}
                    name={SJQXChecks.CKLRSJ}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.CKLRSJ]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.CKLRSJ)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {CKLRSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCKLRSJTypeName(v, getModuleName(SJQXChecks.CKLRSJ))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.CKLRSJ]: 99,
                                })
                                setChecksFlag(SJQXChecks.CKLRSJ)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {/* 导出/打印权限 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.DCDYQX)}
                    name={SJQXChecks.DCDYQX}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.DCDYQX]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.DCDYQX)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {DCDYQXTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getDCDYQXTypeName(v, getModuleName(SJQXChecks.DCDYQX))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.DCDYQX]: 99,
                                })
                                setChecksFlag(SJQXChecks.DCDYQX)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {/* 医生查看交易查询 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.YSCKJYCX)}
                    name={SJQXChecks.YSCKJYCX}
                  >
                    <Radio.Group>
                      {YSCKJYCXTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getYSCKJYCXTypeName(v)}
                        </Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {/* 查看患者手机号 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.TJFXCKHRSJH)}
                    name={SJQXChecks.TJFXCKHRSJH}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.TJFXCKHRSJH]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.TJFXCKHRSJH)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {CKLRSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCKLRSJTypeName(v, getModuleName(SJQXChecks.TJFXCKHRSJH))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.TJFXCKHRSJH]: 99,
                                })
                                setChecksFlag(SJQXChecks.TJFXCKHRSJH)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {/* 查看患者身份证号 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.TJFXCKHZSFZH)}
                    name={SJQXChecks.TJFXCKHZSFZH}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.TJFXCKHZSFZH]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.TJFXCKHZSFZH)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {CKLRSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCKLRSJTypeName(v, getModuleName(SJQXChecks.TJFXCKHZSFZH))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.TJFXCKHZSFZH]: 99,
                                })
                                setChecksFlag(SJQXChecks.TJFXCKHZSFZH)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </div>
              <Row
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  borderBottom: '1px dashed #BBBBBB',
                  paddingBottom: '10px',
                  width: '100%',
                }}
              >
                库房工作站
              </Row>
              <div className={styles.contentJJ}>
                {/* 查看利润数据 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.KFGZZCKLRSJ)}
                    name={SJQXChecks.KFGZZCKLRSJ}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.KFGZZCKLRSJ]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.KFGZZCKLRSJ)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {CKLRSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCKLRSJTypeName(v, getModuleName(SJQXChecks.KFGZZCKLRSJ))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.KFGZZCKLRSJ]: 99,
                                })
                                setChecksFlag(SJQXChecks.KFGZZCKLRSJ)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {/* 导出/打印权限 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.KFGZZDCDYQX)}
                    name={SJQXChecks.KFGZZDCDYQX}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.KFGZZDCDYQX]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.KFGZZDCDYQX)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {DCDYQXTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getDCDYQXTypeName(v, getModuleName(SJQXChecks.KFGZZDCDYQX))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.KFGZZDCDYQX]: 99,
                                })
                                setChecksFlag(SJQXChecks.KFGZZDCDYQX)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </div>
              {hisVersion == 1 ? '' : <>
                <Row
                  style={{
                    fontSize: 16,
                    fontWeight: 'bold',
                    borderBottom: '1px dashed #BBBBBB',
                    paddingBottom: '10px',
                    width: '100%',
                  }}
                >
                  患者管理
                </Row>
                <div>
                  {/* 患者管理查看患者手机号 */}
                  <Col className={styles.rowHeightData} span={24}>
                    <Form.Item
                      label={getSJQXChecksName(SJQXChecks.HZGLCKHZSJH)}
                      name={SJQXChecks.HZGLCKHZSJH}
                    >
                      <Radio.Group
                        onChange={(v) => {
                          setAssignedUserIds((prev: any) => ({
                            ...prev,
                            [SJQXChecks.HZGLCKHZSJH]: []
                          }))
                          const value = v.target.value
                          if (value == 99) {
                            setChecksFlag(SJQXChecks.HZGLCKHZSJH)
                            setIsModalVisible(!isModalVisible)
                          }
                        }}>
                        {CKLRSJTypeOptions.map((v) => {
                          return <Radio key={v} value={v} >
                            {getCKLRSJTypeName(v, getModuleName(SJQXChecks.HZGLCKHZSJH))}
                            {v == 99 ?
                              <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                                onClick={() => {
                                  form.setFieldsValue({
                                    [SJQXChecks.HZGLCKHZSJH]: 99,
                                  })
                                  setChecksFlag(SJQXChecks.HZGLCKHZSJH)
                                  setIsModalVisible(!isModalVisible)
                                }}
                              >查看编辑</span> : ''}</Radio>
                        })}
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  {/* 患者管理查看患者身份证号 */}
                  <Col className={styles.rowHeightData} span={24}>
                    <Form.Item
                      label={getSJQXChecksName(SJQXChecks.HZGLCKHZSFZH)}
                      name={SJQXChecks.HZGLCKHZSFZH}
                    >
                      <Radio.Group
                        onChange={(v) => {
                          setAssignedUserIds((prev: any) => ({
                            ...prev,
                            [SJQXChecks.HZGLCKHZSFZH]: []
                          }))
                          const value = v.target.value
                          if (value == 99) {
                            setChecksFlag(SJQXChecks.HZGLCKHZSFZH)
                            setIsModalVisible(!isModalVisible)
                          }
                        }}>
                        {CKLRSJTypeOptions.map((v) => {
                          return <Radio key={v} value={v} >
                            {getCKLRSJTypeName(v, getModuleName(SJQXChecks.HZGLCKHZSFZH))}
                            {v == 99 ?
                              <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                                onClick={() => {
                                  form.setFieldsValue({
                                    [SJQXChecks.HZGLCKHZSFZH]: 99,
                                  })
                                  setChecksFlag(SJQXChecks.HZGLCKHZSFZH)
                                  setIsModalVisible(!isModalVisible)
                                }}
                              >查看编辑</span> : ''}</Radio>
                        })}
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </div>
              </>}
              {/* 快速开单 */}
              <Row
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  borderBottom: '1px dashed #BBBBBB',
                  paddingBottom: '10px',
                  width: '100%',
                }}
              >
                {tenantCategory == 1 ? '药店开单' : credentials?.isAskMedicine == 1 ? '处方申请' : '快速开单'}
              </Row>
              <div className={styles.contentJJ}>
                {/* 查看患者手机号 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.KSKDCKHRSJH)}
                    name={SJQXChecks.KSKDCKHRSJH}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.KSKDCKHRSJH]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.KSKDCKHRSJH)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {CKLRSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCKLRSJTypeName(v, getModuleName(SJQXChecks.KSKDCKHRSJH, tenantCategory, credentials?.isAskMedicine))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.KSKDCKHRSJH]: 99,
                                })
                                setChecksFlag(SJQXChecks.KSKDCKHRSJH)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {/* 查看患者身份证号 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.KSKDCKHZSFZH)}
                    name={SJQXChecks.KSKDCKHZSFZH}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.KSKDCKHZSFZH]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.KSKDCKHZSFZH)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {CKLRSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCKLRSJTypeName(v, getModuleName(SJQXChecks.KSKDCKHZSFZH, tenantCategory, credentials?.isAskMedicine))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.KSKDCKHZSFZH]: 99,
                                })
                                setChecksFlag(SJQXChecks.KSKDCKHZSFZH)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </div>
              {/* 管理设置 */}
              <Row
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  borderBottom: '1px dashed #BBBBBB',
                  paddingBottom: '10px',
                  width: '100%',
                }}
              >
                管理设置
              </Row>
              <div className={styles.contentJJ}>
                {/* 查看患者手机号 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.GLSZCKHRSJH)}
                    name={SJQXChecks.GLSZCKHRSJH}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.GLSZCKHRSJH]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.GLSZCKHRSJH)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {CKLRSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCKLRSJTypeName(v, getModuleName(SJQXChecks.GLSZCKHRSJH))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.GLSZCKHRSJH]: 99,
                                })
                                setChecksFlag(SJQXChecks.GLSZCKHRSJH)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </div>
              {/* 随访 */}
              <Row
                style={{
                  fontSize: 16,
                  fontWeight: 'bold',
                  borderBottom: '1px dashed #BBBBBB',
                  paddingBottom: '10px',
                  width: '100%',
                }}
              >
                随访
              </Row>
              <div className={styles.contentJJ}>
                {/* 查看患者手机号 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.SFCKHRSJH)}
                    name={SJQXChecks.SFCKHRSJH}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.SFCKHRSJH]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.SFCKHRSJH)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {CKLRSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCKLRSJTypeName(v, getModuleName(SJQXChecks.SFCKHRSJH))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.SFCKHRSJH]: 99,
                                })
                                setChecksFlag(SJQXChecks.SFCKHRSJH)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {/* 查看患者身份证号 */}
                <Col className={styles.rowHeightData} span={24}>
                  <Form.Item
                    label={getSJQXChecksName(SJQXChecks.SFCKHZSFZH)}
                    name={SJQXChecks.SFCKHZSFZH}
                  >
                    <Radio.Group
                      onChange={(v) => {
                        setAssignedUserIds((prev: any) => ({
                          ...prev,
                          [SJQXChecks.SFCKHZSFZH]: []
                        }))
                        const value = v.target.value
                        if (value == 99) {
                          setChecksFlag(SJQXChecks.SFCKHZSFZH)
                          setIsModalVisible(!isModalVisible)
                        }
                      }}>
                      {CKLRSJTypeOptions.map((v) => {
                        return <Radio key={v} value={v} >
                          {getCKLRSJTypeName(v, getModuleName(SJQXChecks.SFCKHZSFZH))}
                          {v == 99 ?
                            <span style={{ color: '#027AFF', paddingLeft: '10px' }}
                              onClick={() => {
                                form.setFieldsValue({
                                  [SJQXChecks.SFCKHZSFZH]: 99,
                                })
                                setChecksFlag(SJQXChecks.SFCKHZSFZH)
                                setIsModalVisible(!isModalVisible)
                              }}
                            >查看编辑</span> : ''}</Radio>
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </div>
            </div>
            <Row>
              <Col span={12}>
                <Button
                  htmlType='button'
                  onClick={() => {
                    getDetail()
                    clearMessage()
                  }}
                  style={{
                    float: 'right',
                    marginRight: '10px',
                  }}
                >
                  取消
                </Button>
              </Col>
              <Col span={12}>
                <Button
                  loading={buttonLoading}
                  type='primary'
                  htmlType='submit'
                  style={{
                    float: 'left',
                  }}
                >
                  保存
                </Button>
              </Col>
            </Row>
          </Form>
        </>
      </div >
      <SelectPeopleModal
        checksFlag={checksFlag}
        assignedUserIds={assignedUserIds[checksFlag] as any}
        visible={isModalVisible}
        onOk={(v: any) => {
          setAssignedUserIds((prev: any) => ({
            ...prev,
            [checksFlag]: v[checksFlag] || []
          }))
          setIsModalVisible(false)
        }}
        onCancel={() => {
          setIsModalVisible(false)
        }}
      />
    </>
  )
}
